import { kebabCase } from 'lodash';

export default class ConfigStrategyManager {
    construct(strategy) {
        this._strategy = strategy;
    }
    set strategy(strategy) {
        this._strategy = strategy;
    }
    get strategy() {
        return this._strategy;
    }
    config() {
        return this._strategy.config();
    }
    doAction() {
        return this._strategy.doAction();
    }
    getCSSClassName() {
        return kebabCase(this._strategy.constructor.name);
    }
}
